import { RecommendationBusinessGoalLinkApi } from "~/api/RecommendationBusinessGoalLink";

export function useRecommendationBusinessGoalLinkApi(): RecommendationBusinessGoalLinkApi {
  const recommendationBusinessGoalLinkApi = new RecommendationBusinessGoalLinkApi(useHttpClient());

  return recommendationBusinessGoalLinkApi;
}
